import { MediaVolumeRange } from 'media-chrome/react';
import { CSSProperties } from 'react';

import { defaultRangeStyling } from './util';

export function PlayerVolumeRange() {
  return (
    <MediaVolumeRange
      className="flex-none w-fit -mr-2.5"
      style={
        {
          '--media-range-track-width': '90px',
          ...defaultRangeStyling,
        } as CSSProperties
      }
    />
  );
}
